/**
 * Botify PageWorkers script loader.
 *
 * Dynamically injects the Botify PageWorkers script on specific pages
 * based on the current pathname. The script is added/removed as users
 * navigate through the SPA to ensure it's only present on relevant pages.
 *
 */

import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getFeatureFlags } from 'utils/feature-flags';
import { botifyPageWorkersPaths } from 'constants/botify-page-workers';

const BOTIFY_SCRIPT_URL = 'https://tags.pw.adn.cloud/5RZA5V/activation.js';

const isBotifyPageWorkersPage = (pathname: string): boolean => {
  return botifyPageWorkersPaths.some(regex => regex.test(pathname));
};

const BotifyPageWorkers = () => {
  const { pathname } = useLocation();
  const featureFlags = getFeatureFlags();

  const shouldIncludeScript = useMemo(() => {
    return !featureFlags.disableBotifyPageWorkers && isBotifyPageWorkersPage(pathname);
  }, [featureFlags.disableBotifyPageWorkers, pathname]);

  if (!shouldIncludeScript) {
    return null;
  }

  return (
    <Helmet>
      <script async src={BOTIFY_SCRIPT_URL} />
    </Helmet>
  );
};

export default BotifyPageWorkers;
